import GitHubIcon from '@mui/icons-material/GitHub';
import SendToMobileIcon from '@mui/icons-material/SendToMobile';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import { Divider, Link } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { makeStyles } from "@mui/styles";
import React from 'react';
const useStyles = makeStyles(theme => ({

    root: {
        backgroundColor: '#18042e !important',
    },
    link: {
        marginTop: '10px !important',
        color: '#10c3eb !important',
        textDecoration: 'none !important',

    },
    media: {
        height: '400px',
        width: '100%',
        paddingTop: '', // 16:9,
        marginTop: '30'
    }
}));
export default function ProjectDetails({ item }) {
    const classes = useStyles();
    return (
        <Card sx={{ flexGrow: 1, backgroundColor: '#18042e', padding: "16px 10px" }}>
            <Grid container>

                <Grid item md={6} lg={6} sm={12}>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <CardContent sx={{ flex: '1 0 auto' }}>
                            <Typography component="div" variant="h5" color='#fff'>
                                {item.name}
                            </Typography>
                            <Typography variant="subtitle1" color="text.secondary" component="div">
                                {item.description}
                            </Typography>
                        </CardContent>
                        <Box >
                            <Box>
                                {item.tools.map(tool => <Button variant="outlined" color="success" sx={{ margin: '5px 5px' }}>
                                    {tool}
                                </Button>)}
                            </Box>
                            <IconButton aria-label="previous">
                                <Link href={item.github} className={classes.link} target={"_blank"} style={{ marginTop: '10px' }}>
                                    <GitHubIcon />
                                </Link>
                            </IconButton>
                            <IconButton aria-label="next"><Link href={item.liveSite} className={classes.link} target={"_blank"} style={{ marginTop: '10px' }}>
                                <SendToMobileIcon />
                            </Link>
                            </IconButton>
                        </Box>
                    </Box>
                </Grid>

                <Grid item md={6} lg={6} sm={12}>
                    <CardMedia
                        component="img"
                        // sx={{ height: '350px', width: '700px' }}
                        className={classes.media}
                        image={`${item.img}`}
                        alt="Live from space album cover"
                    />
                </Grid>
            </Grid>
            <Divider component='elementType' sx={{
                color: '#10B981', padding: '15px 0', "&::before, &::after": {
                    borderColor: "secondary.light",
                    borderWidth: 3
                }
            }}>
                <StarHalfIcon />
            </Divider>
        </Card>

    )
}
